/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {searchMusicResources} from '../api'

export const useMutationSearchMusicResources = createReactQueryMutationHook('searchMusicResources', searchMusicResources)
